'use client';

import React from 'react';
import { Select } from '@mantine/core';
import { useLanguage, Language } from '@/context/LanguageContext';

const languages = [
  { value: 'pl', label: 'Polski', flag: '🇵🇱' },
  { value: 'en', label: 'English', flag: '🇬🇧' },
  { value: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { value: 'it', label: 'Italiano', flag: '🇮🇹' },
  { value: 'fr', label: 'Français', flag: '🇫🇷' },
  { value: 'es', label: 'Español', flag: '🇪🇸' },
];

export const LanguageSelector: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  const handleChange = (value: string | null) => {
    if (value) {
      setLanguage(value as Language);
    }
  };

  const selectedLanguage = languages.find(lang => lang.value === language);

  return (
    <Select
      value={language}
      onChange={handleChange}
      data={languages.map(lang => ({
        value: lang.value,
        label: lang.label,
      }))}
      leftSection={<span style={{ fontSize: '18px' }}>{selectedLanguage?.flag || '🌐'}</span>}
      renderOption={({ option }) => {
        const lang = languages.find(l => l.value === option.value);
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '18px' }}>{lang?.flag}</span>
            <span>{lang?.label}</span>
          </div>
        );
      }}
      size="sm"
      styles={{
        input: {
          minWidth: '140px',
        },
      }}
    />
  );
};

